<template>
  <div class="components-part pointer" :style="{background: home ? 'white' : '#f1f8ff', height: home ? 'auto' : '500px'}">
    <div v-if="!home" class="title">您可能还对下列功能感兴趣</div>
    <div class="info">
      <div v-for="(item,i) in partList" :key="i" @click="goTo(item.path)" class="item">
        <div class="image">
          <img :src="item.img" alt=""/>
        </div>
        <div class="info-title">{{ item.title }}</div>
        <div class="info-desc">
          {{ item.desc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartList',
  props: {
    partList: {
      type: Array,
      default: () => []
    },
    home: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  methods: {
    goTo(path) {
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style scoped lang="scss">
.components-part{
  /*height: 500px;*/
  text-align: center;
  /*background: #f1f8ff;*/
  .title{
    font-size: 30px;
    padding-top: 45px;
  }
  .info{
    display: flex;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    .item{
      width: 150px;
      .image{
        height: 190px;
        display: flex;
        align-items: flex-end;
        flex-direction: row-reverse;
        justify-content: center;
      }
      img{
        width: 120px;
      }
      .info-title{
        margin-top: 50px;
        margin-bottom: 20px;
        font-size: 20px;
      }
      .info-desc{
        font-size: 13px;
        color: #999;
      }
    }
  }
}
</style>
